<div class="billing-summary mt-4">
    <div class="row">
        <div class="col-md-3">
            <div class="card text-center">
                <div class="card-body">
                    <h6 class="card-title">Total Bills</h6>
                    <p class="card-text h4">{{ serviceTotalBills }}</p>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center">
                <div class="card-body">
                    <h6 class="card-title">Grand Total</h6>
                    <p class="card-text h5 text-primary">
                        {{ formatCurrency(serviceTotalAmount) }}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center">
                <div class="card-body">
                    <h6 class="card-title">Total GST</h6>
                    <p class="card-text h6 text-info">
                        {{ formatCurrency(serviceTotalGst) }}
                    </p>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center">
                <div class="card-body">
                    <h6 class="card-title">Total Discount</h6>
                    <p class="card-text h6 text-success">
                        {{ formatCurrency(serviceTotalDiscount) }}
                    </p>
                </div>
            </div>
        </div>
    </div>

    <div class="row mt-3 mb-4 align-items-center">
        <div class="col-md-3">
            <div class="card text-center shadow-sm">
                <div class="card-body py-2">
                    <h6 class="card-title mb-1 small text-muted">Get Sales Report</h6>
                    <button class="btn btn-outline-success btn-sm" (click)="openReportModal()">
                        <i class="bi bi-file-earmark-excel"></i> Export CSV
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-3">
            <div class="card text-center shadow-sm">
                <div class="card-body py-2">
                    <h6 class="card-title mb-1 small text-muted">Refresh Data</h6>
                    <button class="btn btn-outline-secondary btn-sm" [disabled]="isLoading" (click)="refreshData()">
                        <i class="bi bi-arrow-clockwise"></i>
                        {{ isLoading ? "Loading..." : "Refresh" }}
                    </button>
                </div>
            </div>
        </div>
        <div class="col-md-3 ms-auto">
            <div class="input-group shadow-sm">
                <span class="input-group-text bg-white border-end-0">
                    <i class="bi bi-search text-primary"></i>
                </span>
                <input type="text" class="form-control border-start-0 ps-0" [formControl]="searchControl" placeholder="Search by recipient name or number...">
            </div>
        </div>
    </div>

    <div class="common-table">
        <div class="table-responsive" style="max-height: 65vh; overflow-y: auto; overflow-x: auto;">
            <table class="table">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>service no.</th>
                        <th>Recipient</th>
                        <th>Billing Date</th>
                        <th>Service Provider</th>
                        <th>Discount</th>
                        <th>GST</th>
                        <th>Grand Total</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    @if (!serviceBillingList.length) {
                    <tr>
                        <td colspan="8" class="text-center">
                            @if (isLoading) {
                            <div class="d-flex justify-content-center align-items-center py-3">
                                <div class="spinner-border" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                                <span class="ms-2">Loading service bills...</span>
                            </div>
                            } @else {
                            <span>No service bills found.</span>
                            }
                        </td>
                    </tr>
                    } @for (bill of serviceBillingList; track bill.id; let i = $index) {
                    <tr>
                        <td>{{ i + 1 }}</td>
                        <td>
                            <a href="javascript:void(0)" (click)="navigateToDetails(bill.id)" class="text-primary fw-bold text-decoration-none">
                              {{ bill.serviceNumber || "N/A" }}
                            </a>
                        </td>
                        <td>
                            <span class="fw-semibold text-dark">{{ bill.recipient?.name || "N/A" }}</span>
                            @if (bill.recipient?.email) {
                                <small class="text-muted d-block">{{ bill.recipient.email }}</small>
                            }
                        </td>
                        <td>
                            <div>
                                <strong class="text-muted d-block">{{ formatDateTime(bill.createdAt) }}</strong>
                            </div>
                        </td>
                        <td>{{ getProviderNames(bill) }}</td>
                        <td>{{ formatCurrency(bill.totalDiscount || bill.discount || "0") }}</td>
                        <td>{{ formatCurrency(bill.gstAmount || "0") }}</td>
                        <td>{{ formatCurrency(bill.grandTotal || bill.total || "0") }}</td>
                        <td>
                            <div class="td-actions-btn">
                                <button class="btn btn-warning btn-sm" (click)="downloadServicePDF(bill.id)"
                                    title="Download PDF">
                                    <i class="bi bi-download"></i>
                                </button>
                            </div>
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    @if (serviceTotalCount > pageSize) {
    <div class="d-flex justify-content-center mt-4">
        <nav>
            <ul class="pagination">
                <li class="page-item" [class.disabled]="servicePage === 1">
                    <button class="page-link" (click)="getServiceBillingList(servicePage - 1)">
                        &laquo;
                    </button>
                </li>
                @for (page of serviceVisiblePages; track page) {
                <li class="page-item" [class.active]="servicePage === page">
                    <button class="page-link" (click)="getServiceBillingList(page)">
                        {{ page }}
                    </button>
                </li>
                }
                <li class="page-item" [class.disabled]="servicePage === serviceTotalPages">
                    <button class="page-link" (click)="getServiceBillingList(servicePage + 1)">
                        &raquo;
                    </button>
                </li>
            </ul>
        </nav>
    </div>
    }
</div>

<!-- Report Modal -->
<div class="modal fade" tabindex="-1" [ngClass]="{ 'show d-block': showReportModal }"
    [style.display]="showReportModal ? 'block' : 'none'">
    <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title">Export Data to CSV</h5>
                <button type="button" class="btn-close" (click)="closeReportModal()" aria-label="Close"></button>
            </div>

            <div class="modal-body">
                <div class="mb-4 p-3 border rounded">
                    <div class="mb-3">
                        <label class="form-label fw-bold text-dark">Quick Select Presets:</label>
                        <div class="d-flex flex-wrap gap-2">
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'today' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('today')">Today</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'yesterday' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('yesterday')">Yesterday</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'weekToDate' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('weekToDate')">Week to date</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'monthToDate' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('monthToDate')">Month to date</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'yearToDate' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('yearToDate')">Year to date</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'previousWeek' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('previousWeek')">Previous week</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'previousMonth' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('previousMonth')">Previous month</button>
                            <button type="button" class="btn"
                                [ngClass]="selectedPreset === 'previousYear' ? 'btn-success' : 'btn-secondary'"
                                (click)="setRelative('previousYear')">Previous year</button>
                        </div>
                    </div>

                    <div class="mt-3">
                        <label class="form-label fw-bold text-dark">Or select a custom range:</label>
                        <div class="d-flex align-items-center gap-2">
                            <input type="date" class="form-control" [(ngModel)]="fromDate" />
                            <span class="text-muted">to</span>
                            <input type="date" class="form-control" [(ngModel)]="toDate" />
                        </div>
                    </div>
                    <small class="text-muted mt-2 d-block">Manual date selection overrides any preset choice.</small>
                </div>
            </div>

            <div class="modal-footer">
                <button class="btn btn-success" (click)="downloadReport()">Download CSV</button>
                <button class="btn btn-secondary" (click)="closeReportModal()">Cancel</button>
            </div>
        </div>
    </div>
</div>